import { UseAnnotations } from "helpers/hooks/useAnnotations";
import { createContext } from "react";

export const AnnotationsContext = createContext<UseAnnotations>(null!);
